import request from "@/utils/request";

export function userKpiListApi(params) {
  return request({
    url: "?c=kpi&a=user&do=list",
    method: "get",
    params
  });
}

export function userOrderApi(params) {
  return request({
    url: "?c=kpi&a=workorder&do=list",
    method: "get",
    params
  });
}

export function checkOrderApi(data) {
  return request({
    url: "?c=kpi&a=workorder&do=single-post",
    method: "post",
    data: data
  });
}

export function sumApi(params) {
  return request({
    url: "?c=kpi&a=stat&do=summarize",
    method: "get",
    params
  });
}

export function rankApi(params) {
  return request({
    url: "?c=kpi&a=stat&do=rank",
    method: "get",
    params
  });
}

export function checkUserDApi(params) {
  return request({
    url: "?c=kpi&a=user&do=check_detail",
    method: "get",
    params
  });
}

export function kpiDLApi(params) {
  return request({
    url: "?c=kpi&a=detail&do=list",
    method: "get",
    params
  });
}

export function exportKDApi(params) {
  return request({
    url: "?c=kpi&a=user&do=export",
    method: "get",
    params
  });
}

export function exportDetailApi(params) {
  return request({
    url: "?c=kpi&a=detail&do=export",
    method: "get",
    params
  });
}

export function batchWorderApi(data) {
  return request({
    url: "?c=kpi&a=workorder&do=batch-post",
    method: "post",
    data: data
  });
}

export function exportWOApi(params) {
  return request({
    url: "?c=kpi&a=workorder&do=export",
    method: "get",
    params
  });
}
